"use client"

import type React from "react"
import style from "./deleteConfirmationModal.module.css"
import Modal from "../../../UI/DataTable/modal/modal"
import AppGetIcon from "../../AppGetIcon"


interface DeleteConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
  itemName?: string
  customMessage?: string
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  itemName,
  customMessage,
}) => {
  return (
    <Modal
      title="Confirmación de Eliminación"
      isOpen={isOpen}
      onClose={onClose}
      size={{ width: "450px", height: "" }}
      footerContent={
        <div className={style.containerButtoms}>
          <button className={`${style.buttomFooter} ${style.buttom_cancelar}`} onClick={onClose} disabled={loading}>
            Cancelar
          </button>
          <button type="button" className={style.buttomFooter} onClick={onConfirm} disabled={loading}>
            {loading ? (
              <>
                <div className="animate-spin w-3 h-3 border-2 border-white border-t-transparent rounded-full"></div>
                Eliminando...
              </>
            ) : (
              "Sí, Eliminar"
            )}
          </button>
        </div>
      }
    >
      <div style={{ padding: "12px", textAlign: "center" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "12px",
          }}
        >
          <div
            style={{
              width: "36px",
              height: "36px",
              background: "#fef2f2",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #fecaca",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.1)"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)"
            }}
          >
            <AppGetIcon name="warning" strokeColor="var(--color-on-surface-variant-main)" />

          </div>
        </div>

        <div style={{ marginBottom: "8px" }}>
          <h3 className={style.titleDelete}>
            {customMessage || "¿Está seguro que desea eliminar el registro?"}
          </h3>
        </div>

        <p
          style={{
            fontSize: "12px",
            color: "#ef4444",
            fontWeight: "500",
            margin: 0,
          }}
        >
          ⚠️ Esta acción no se puede deshacer
        </p>
      </div>
    </Modal>
  )
}

export default DeleteConfirmationModal
